import type { EnrollmentTypeAgeEnforcementMode } from '~/resources/graphql/graphql'
import { randomString } from '~/composables/support/util'

export type EnrollmentInputArray = EnrollmentInput[]

export type EnrollmentInput = {
    enrollmentType: {
        id: string
        singular: string
        ageEnforcementMode: EnrollmentTypeAgeEnforcementMode
        ageMinimum: number
        ageMaximum: number
        requireContractHolder: boolean
    }
    count: number
    enrollments: EnrollmentInputEnrollment[]
    minQuantity?: number
    maxQuantity?: number
}

export type EnrollmentInputEnrollment = {
    data: EnrollmentInputEnrollmentData
    invalid: boolean
    invalidFromConstraint: boolean
}

export type EnrollmentInputEnrollmentData =
    | EnrollmentInputExistingEnrollment
    | EnrollmentInputNewEnrollment
    | null

export type EnrollmentInputExistingEnrollment = {
    type: 'existing'
    id: string
    commaName: string
    firstName: string
    lastName: string
    middleName: string
    dateOfBirth: string
}

export type EnrollmentInputNewEnrollment = {
    type: 'new'
    key: string
    firstName: string
    lastName: string
    middleName: string
    dateOfBirth: string
    householdMember: boolean
}

export function makeEmptyEnrollmentInput(): EnrollmentInputEnrollment {
    return {
        data: {
            type: 'new',
            key: randomString(),
            firstName: '',
            lastName: '',
            middleName: '',
            dateOfBirth: '',
            householdMember: true
        },
        invalid: true,
        invalidFromConstraint: false
    }
}

export function makeNullEnrollmentInput(): EnrollmentInputEnrollment {
    return {
        data: null,
        invalid: true,
        invalidFromConstraint: false
    }
}

export const enrollmentInputArrayValidator = (
    payload: EnrollmentInputArray
) => {
    return (
        Array.isArray(payload) &&
        payload.every(
            value =>
                typeof value.enrollmentType === 'object' &&
                typeof value.enrollmentType.id === 'string' &&
                value.enrollmentType.id !== '' &&
                typeof value.enrollmentType.singular === 'string' &&
                value.enrollmentType.singular !== '' &&
                value.count >= 0 &&
                Array.isArray(value.enrollments)
        )
    )
}

export const enrollmentTypePickerValidator = (
    payload: EnrollmentInputArray
) => {
    return (
        Array.isArray(payload) &&
        payload.every(
            value =>
                typeof value.enrollmentType === 'object' &&
                typeof value.enrollmentType.id === 'string' &&
                value.enrollmentType.id !== '' &&
                typeof value.enrollmentType.singular === 'string' &&
                value.enrollmentType.singular !== '' &&
                value.count >= 0 &&
                typeof value.minQuantity === 'number' &&
                value.minQuantity >= 0 &&
                typeof value.maxQuantity === 'number' &&
                value.maxQuantity >= 1
        )
    )
}
